import PropTypes from 'prop-types';
import { clsx } from 'clsx';
import InfoIcon from './icons/infocircle.svg?react';

export function ActionRow({
  label,
  description,
  action,
  tooltip,
  showSeparator = false,
  className = '',
}) {
  return (
    <div
      className={clsx(
        'flex justify-between items-center',
        'py-spacing-2 px-spacing-4',
        showSeparator && 'border-t border-border-divider',
        className
      )}
    >
      <div className="flex-1 min-w-0">
        <span className="text-dls-body text-primary">{label}</span>
        {description && (
          <p className="text-dls-small text-secondary mt-spacing-1">{description}</p>
        )}
      </div>
      <div className="ml-spacing-4 flex-shrink-0 flex items-center gap-spacing-2">
        {action}
        {tooltip && (
          <div className="relative group">
            <InfoIcon className="cursor-help size-4 text-secondary hover:text-primary transition-colors" />
            <div className="absolute right-0 bottom-full mb-spacing-2 w-[256px] p-spacing-2 bg-bg-tooltip text-[12px] text-primary rounded-lg opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none z-10 border border-border-default whitespace-pre-line">
              {tooltip}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

ActionRow.propTypes = {
  label: PropTypes.string.isRequired,
  description: PropTypes.string,
  action: PropTypes.node.isRequired,
  tooltip: PropTypes.string,
  showSeparator: PropTypes.bool,
  className: PropTypes.string,
};
